import React from 'react';
import DishNameField from './components/DishNameField';
import CustomersField from './components/CustomersField';
import ArticleField from './components/ArticleField';
import RestaurantsField from './components/RestaurantsField';
import DescriptionField from './components/DescriptionField';
import PosNameField from './components/PosNameField';

const MainInfoSection: React.FC = () => {
	return (
		<>
			<DishNameField />
			<CustomersField />
			<ArticleField />
			<RestaurantsField />
			<DescriptionField />
			<PosNameField />
		</>
	);
};

export default MainInfoSection;
